// Public contact addresses for the legal pages.
//
// NomLoop controls nomloop.uk but has no mailbox on it yet, and nomloop.com
// belongs to a third party, so no address is hard-coded. Set these at build
// time once a mailbox exists:
//   VITE_PRIVACY_EMAIL=...   VITE_SUPPORT_EMAIL=...
// Unset, the legal pages show a fallback instead of a mailto link.

const clean = (v) => (typeof v === "string" && v.includes("@") ? v.trim() : null);

export const PRIVACY_EMAIL = clean(import.meta.env?.VITE_PRIVACY_EMAIL);
export const SUPPORT_EMAIL = clean(import.meta.env?.VITE_SUPPORT_EMAIL) || PRIVACY_EMAIL;
